import { classNames } from 'libs/react';
import { useState } from 'libs/react';
import { Button } from './Button';
import { Case } from './util/Case';
import { Icon } from 'components/Icon';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import './Panel.scss';
/**
 * @component Panel
 * @since 1.0.0
 */
export function Panel(props) {
    const { style, title, infos, picto, ratio, collapsible, collapse } = Object.assign({ style: 'normal', ratio: 'auto', collapsible: false, collapse: false }, props);
    const [collapsed, setCollapsed] = useState(collapse);
    function onCollapseButtonPress() {
        if (collapsible)
            setCollapsed((collapsed) => !collapsed);
    }
    const className = classNames('panel', 'panel--' + style, 'panel--' + ratio, { 'panel--is-collapsed': collapsed }, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "panel-head", onClick: onCollapseButtonPress },
            React.createElement(Case, { is: picto },
                React.createElement("div", { className: "panel-head-side" },
                    React.createElement(Icon, { className: "panel-picto", value: picto }))),
            React.createElement(Case, { is: title || infos },
                React.createElement("div", { className: "panel-head-main" },
                    title && React.createElement(Text, { className: "panel-title", value: title }),
                    infos && React.createElement(Text, { className: "panel-infos", value: infos }))),
            React.createElement(Case, { is: collapsible },
                React.createElement(Button, { className: "panel-collapse-button", style: "picto", picto: "chevron-up" }))),
        React.createElement("div", { className: "panel-body" }, props.children)));
}
